import type { StatusVariant } from '../../utils/statusUtils';

/**
 * The one pill treatment (W-M5): a darker outline, a light tint of the same colour and darker
 * text of that colour - the look the Projects "Active" pill always had. Uses Tailwind's palette
 * steps so the text clears 4.5:1 on its own tint.
 */
export const STATUS_TONES: Record<StatusVariant, string> = {
  secondary: 'tw-bg-slate-100 tw-text-slate-700 tw-border-slate-400',
  primary: 'tw-bg-blue-50 tw-text-blue-800 tw-border-blue-600',
  success: 'tw-bg-green-50 tw-text-green-800 tw-border-green-600',
  teal: 'tw-bg-teal-50 tw-text-teal-800 tw-border-teal-600',
  warning: 'tw-bg-amber-50 tw-text-amber-800 tw-border-amber-500',
  yellow: 'tw-bg-yellow-50 tw-text-yellow-800 tw-border-yellow-500',
  orange: 'tw-bg-orange-50 tw-text-orange-800 tw-border-orange-500',
  dark: 'tw-bg-slate-200 tw-text-slate-800 tw-border-slate-600',
  purple: 'tw-bg-purple-50 tw-text-purple-800 tw-border-purple-600',
  danger: 'tw-bg-red-50 tw-text-red-800 tw-border-red-600',
  info: 'tw-bg-cyan-50 tw-text-cyan-800 tw-border-cyan-600',
  light: 'tw-bg-surface-alt tw-text-content tw-border-line-input',
};

/** Shared pill shell, exported so ServiceAreaPill and type pills look identical. */
export const PILL_SHELL =
  'tw-inline-flex tw-max-w-full tw-shrink-0 tw-items-center tw-gap-1 tw-whitespace-nowrap tw-align-middle tw-rounded-full tw-border tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4';

